module.exports = __webpack_public_path__ + "media/images/page/featurelp-main-catch-image-0317dbbe619997b0e0725788bb46e8f6.png";